<template>
    <div class="contacts__map" v-if="lot" style="height:250px">
        <div style="margin: auto;width: 60%;padding: 10px;">
           <share-network v-for="network in networks"
               :network="network.network"
               :key="network.network"
               :style="{backgroundColor: network.color}"
               :url="'https://antiqbay.com/lot/'+ lot.id"
               :title="lot.title"
               :description="lot.description"
               :quote="sharing.quote"
               :hashtags="sharing.hashtags"
               :twitterUser="sharing.twitterUser"
               :media="lot.photos ? lot.photos[0] : ''">
               <i :class="network.icon"></i>
               <span>{{ network.name }}</span>
           </share-network>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import {store} from "../../../store/lot";

    export default {
        name: "socialPopup",
        store,
        data: () => ({
            sharing: {
                quote: 'The hot reload is so fast it\'s near instant. - Evan You',
            },
            networks: [
                { network: 'odnoklassniki', name: 'Odnoklassniki', icon: 'fab fah fa-lg fa-odnoklassniki', color: '#ed812b' },
                { network: 'telegram', name: 'Telegram', icon: 'fab fah fa-lg fa-telegram-plane', color: '#0088cc' },
                { network: 'viber', name: 'Viber', icon: 'fab fah fa-lg fa-viber', color: '#59267c' },
                { network: 'vk', name: 'Vk', icon: 'fab fah fa-lg fa-vk', color: '#4a76a8' },
                { network: 'whatsapp', name: 'Whatsapp', icon: 'fab fah fa-lg fa-whatsapp', color: '#25d366' },
            ]
        }),
        computed: {
            ...mapState([
                'lot',
            ]),
        },
    }
</script>

<style>
    #share-network-list {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        max-width: 1000px;
        margin: auto;
    }

    a[class^="share-network-"] {
        flex: none;
        color: #FFFFFF;
        background-color: #333;
        border-radius: 3px;
        overflow: hidden;
        display: flex;
        flex-direction: row;
        align-content: center;
        align-items: center;
        cursor: pointer;
        margin: 0 10px 10px 0;
        text-decoration: none;
    }

    a[class^="share-network-"] .fah {
        background-color: rgba(0, 0, 0, 0.2);
        padding: 10px;
        flex: 0 1 auto;
    }

    a[class^="share-network-"] span {
        padding: 0 10px;
        flex: 1 1;
        font-weight: 500;
    }

    a.share-network-twitter {
        background-color: #1da1f2;
    }

    a.share-network-fakeblock {
        background-color: #41b883;
    }
</style>